<template>
    <section id="project_three_content">

        <div class="row" id="first_row">

            <!-- In Small Screen -->
            <h3 class="mt-4 mb-0 d-block d-lg-none">دوري الروبوت ARSL</h3>

            <div class="col-12 col-lg-6 mt-3 mt-lg-4 order-2 order-lg-1">

                <div class="col_one_content d-flex flex-column justify-content-start w-100 h-100">

                    <h3 class="d-none d-lg-block">دوري الروبوت ARSL</h3>

                    <p>دوري الروبوت والذكاء الاصطناعي لكرة القدم يهدف إلى تطوير مهارات الذكاء الاصطناعي في التصميم والتصنيع والبرمجة من خلال منافسات رياضية للعب كرة القدم بشكل متزامن آلي وتحكم يدوي حسب استراتيجية الفرق وتقام بنظام المباريات.</p>

                    <h5 class="mt-3">الهدف من الدوري</h5>

                    <p>نشأت هذه المسابقة على تعزيز وتطوير مهارات التفكير لدى الرياضيين والأشخاص المهتمين في التحدي والمنافسة، حيث انه تم طرح هذه المنافسة على شكل لعبة كرة قدم يلعبها الروبوت، والتي بدأت في تشجيع البحث والتطوير في تقنيات الروبوت والذكاء الاصطناعي من خلال المنافسات الودية باستخدام روبوتات مخصصة يتم بنائها من قبل الفريق المشارك لتعزيز مهارتهم في استخدام أدوات الثورة الصناعية الرابعة بالاضافة الى الرياضات اللاسلكية وكيفية استخدام وتوظيف الروبوتات بها.</p>

                </div>

            </div>

            <div class="col-12 col-lg-6 mt-3 mt-lg-4 d-flex justify-content-center align-items-start order-1 order-lg-2">

                <div class="col_two_content">
                    <div class="img_wrapper">
                        <img src="@/assets/images/projects/project_three_img.webp" alt="">
                    </div>
                </div>

            </div>

        </div>

        <div class="row mb-3 mb-lg-0 d-flex justify-content-center" id="second_row">

            <h5 class="mt-3 mb-0">تعرف على فئات البطولة</h5>

            <div class="mt-3 my_col">

                <div class="col_three_content w-100 h-100">

                    <!-- <router-link :to="{ name: '' }"> -->
                        <div class="card p-3">
                            <div class="image_wrapper">
                                <img class="card-img-top" src="@/assets/images/services/sport_ropots.webp" alt="" />
                            </div>
                            <div class="card-body">
                                <h5 class="card-title text-center">دوري المبتدئين</h5>
                            </div>
                        </div>
                    <!-- </router-link> -->

                </div>

            </div>

            <div class="mt-3 my_col">

                <div class="col_three_content w-100 h-100">

                    <!-- <router-link :to="{ name: '' }"> -->
                        <div class="card p-3">
                            <div class="image_wrapper">
                                <img class="card-img-top" src="@/assets/images/services/sport_ropots.webp" alt="" />
                            </div>
                            <div class="card-body">
                                <h5 class="card-title text-center">الدوري المتقدم</h5>
                            </div>
                        </div>
                    <!-- </router-link> -->

                </div>

            </div>

            <div class="mt-3 my_col">

                <div class="col_three_content w-100 h-100">

                    <!-- <router-link :to="{ name: '' }"> -->
                        <div class="card p-3">
                            <div class="image_wrapper">
                                <img class="card-img-top" src="@/assets/images/services/sport_ropots.webp" alt="" />
                            </div>
                            <div class="card-body">
                                <h5 class="card-title text-center">دوري المحترفين</h5>
                            </div>
                        </div>
                    <!-- </router-link> -->

                </div>

            </div>

        </div>

    </section>
</template>

<script>
export default {
    name: 'ProjectThree',
}
</script>

<style lang="scss" scoped>
#project_three_content {

    #first_row {

        h3 {
            font-family: 'FFShamelFamily-Bold';
            color: $Green;
            font-size: 18px;
            line-height: 180%;
        }

        .col_one_content {

            p {
                color: $White;
                font-size: 16px;
                line-height: 180%;
                text-align: justify;
                margin-bottom: 0;
            }

            h5 {
                font-family: 'FFShamelFamily-Bold';
                font-size: 16px;
                line-height: 156%;
                color: $Green;
            }

        }

        // https://stackoverflow.com/questions/31854185/how-to-add-border-in-my-clip-path-polygon-css-style
        .col_two_content {

            position: relative;

            width: 636px;
            height: 426px;

            @include breakpoints(x-small) {
                width: 351px;
                height: 235px;
            }

            @include breakpoints(small) {
                width: 516px;
                height: 345px;
            }

            @include breakpoints(medium) {
                width: 696px;
                height: 466px;
            }

            @include breakpoints(large) {
                width: 456px;
                height: 305px;
            }

            @include breakpoints(x-Large) {
                width: 546px;
                height: 366px;
            }

            background: $Green;
            box-sizing: border-box;

            // https://www.cssportal.com/css-clip-path-generator/
            // CSS Vendor Prefixes
            -webkit-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
            -moz-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
            -o-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
            -ms-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
            clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);

            .img_wrapper {

                position: absolute;
                top: 1px;
                left: 1px;

                width: 634px;
                height: 424px;

                @include breakpoints(x-small) {
                    width: 349px;
                    height: 233px;
                }

                @include breakpoints(small) {
                    width: 514px;
                    height: 343px;
                }

                @include breakpoints(medium) {
                    width: 694px;
                    height: 464px;
                }

                @include breakpoints(large) {
                    width: 454px;
                    height: 303px;
                }

                @include breakpoints(x-Large) {
                    width: 544px;
                    height: 364px;
                }

                // https://www.cssportal.com/css-clip-path-generator/
                // CSS Vendor Prefixes
                -webkit-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                -moz-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                -o-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                -ms-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);

                // border: solid 2px $Green;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    opacity: 0.9;
                }

                img:hover {
                    opacity: 1;
                    -webkit-transition: opacity 0.5s linear 0.2s;
                    -moz-transition: opacity 0.5s linear 0.2s;
                    transition: opacity 0.5s linear 0.2s;
                }

            }

        }

    }

    #second_row {

        h5 {

            font-family: 'FFShamelFamily-Bold';
            font-size: 16px;
            line-height: 156%;
            color: $Yellow;
        }

        .my_col {

            width: calc(100% / 3);

            @include breakpoints(x-small) {
                width: calc(100% / 2);
            }

            @include breakpoints(small) {
                width: calc(100% / 2);
            }

            .col_three_content {

                .card {

                    background: $Dark-Green;

                    // CSS Vendor Prefixes
                    -webkit-clip-path: polygon(0% 3%, 0% 3%, 0% 80%, 0% 80%, 3% 85%, 3% 85%, 10% 85%, 10% 85%, 23% 100%, 23% 100%, 97% 100%, 97% 100%, 100% 97%, 100% 97%, 100% 3%, 100% 3%, 97% 0%, 97% 0%, 3% 0%, 3% 0%);
                    -moz-clip-path: polygon(0% 3%, 0% 3%, 0% 80%, 0% 80%, 3% 85%, 3% 85%, 10% 85%, 10% 85%, 23% 100%, 23% 100%, 97% 100%, 97% 100%, 100% 97%, 100% 97%, 100% 3%, 100% 3%, 97% 0%, 97% 0%, 3% 0%, 3% 0%);
                    -o-clip-path: polygon(0% 3%, 0% 3%, 0% 80%, 0% 80%, 3% 85%, 3% 85%, 10% 85%, 10% 85%, 23% 100%, 23% 100%, 97% 100%, 97% 100%, 100% 97%, 100% 97%, 100% 3%, 100% 3%, 97% 0%, 97% 0%, 3% 0%, 3% 0%);
                    -ms-clip-path: polygon(0% 3%, 0% 3%, 0% 80%, 0% 80%, 3% 85%, 3% 85%, 10% 85%, 10% 85%, 23% 100%, 23% 100%, 97% 100%, 97% 100%, 100% 97%, 100% 97%, 100% 3%, 100% 3%, 97% 0%, 97% 0%, 3% 0%, 3% 0%);
                    clip-path: polygon(0% 3%, 0% 3%, 0% 80%, 0% 80%, 3% 85%, 3% 85%, 10% 85%, 10% 85%, 23% 100%, 23% 100%, 97% 100%, 97% 100%, 100% 97%, 100% 97%, 100% 3%, 100% 3%, 97% 0%, 97% 0%, 3% 0%, 3% 0%);

                    /* height: 200px;

                    @include breakpoints(x-small) {
                        height: 230px;
                    }

                    @include breakpoints(small) {
                        height: 230px;
                    }

                    @include breakpoints(medium) {
                        height: 220px;
                    } */

                    .image_wrapper {
                        width: 60%;
                        height: 80px;
                        margin: auto;

                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: contain;
                        }
                    }

                    .card-body {

                        h5 {
                            font-family: 'FFShamelFamily-Bold';
                            font-size: 16px;
                            line-height: 156%;
                            color: $White;
                        }

                    }

                }

                .card:hover {
                    background: $Linear-Blue;
                }

            }

        }

    }

}
</style>